// Legacy SVG icons that are still needed
// These are special cases that don't have Material icon equivalents

export const HappyInbox = (props) => (
  <svg
    width="112"
    height="100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.84 13.597h85.006V67.77H13.84V13.597Z"
      fill="#D6DAE0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.84 13.597v82.288H.13v-49.76l13.71-32.528ZM98.846 13.597V95.2h13.025V46.126L98.846 13.597Z"
      fill="#C1C8D4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.746 4H87.87a2.41 2.41 0 0 1 2.41 2.41v25.457a2.41 2.41 0 0 1-2.41 2.41H24.747a2.41 2.41 0 0 1-2.41-2.41V6.41A2.41 2.41 0 0 1 24.746 4h-.001Z"
      fill="#F8EBEE"
      stroke="#fff"
      strokeWidth="6.497"
    />
    <path
      d="M93.333 14.53H19.277a.567.567 0 0 0-.567.567v32.351c0 .313.253.567.567.567h74.056a.567.567 0 0 0 .567-.567V15.097a.567.567 0 0 0-.567-.567Z"
      fill="#EFE8D8"
      stroke="#fff"
      strokeWidth="7.219"
    />
    <path
      d="M96.974 27.095H14.943a.567.567 0 0 0-.567.567v36.305c0 .313.253.567.567.567h82.03a.567.567 0 0 0 .568-.567V27.662a.567.567 0 0 0-.567-.567Z"
      stroke="#fff"
      strokeWidth="8.021"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.13 45.827H111.87v50.752c0 1.89-1.532 3.421-3.421 3.421H3.55a3.42 3.42 0 0 1-3.42-3.42V45.826v.001Z"
      fill="#F0F2F7"
    />
    <path
      opacity=".391"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.395 65.115c1.19-.515 2.363-.773 3.52-.773 1.132 0 2.265.247 3.397.74a2.819 2.819 0 0 1 1.691 2.583.971.971 0 0 1-1.387.877c-1.233-.585-2.475-.877-3.727-.877-1.258 0-2.516.295-3.774.886a.98.98 0 0 1-1.395-.886c0-1.108.658-2.11 1.675-2.55Zm34.962 0c1.19-.515 2.363-.773 3.52-.773 1.132 0 2.265.247 3.397.74a2.819 2.819 0 0 1 1.691 2.583.971.971 0 0 1-1.387.877c-1.233-.585-2.475-.877-3.727-.877-1.258 0-2.516.295-3.774.886a.98.98 0 0 1-1.395-.886c0-1.108.658-2.11 1.675-2.55ZM56.343 83.546c6.057 0 10.968-3.54 10.968-9.6-10.968-.036-13.327.175-21.937 0 0 6.06 4.911 9.6 10.969 9.6Z"
      fill="#1B3554"
    />
  </svg>
);

export const LaptopRobot = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90" focusable="false">
    <g fill="none" fillRule="evenodd" stroke="#000" transform="translate(1 1)">
      <rect width="52" height="33" x="18" y="18" rx="3" />
      <path d="M70 78v-9.333a4.701 4.701 0 0 0-1.342-3.302A4.543 4.543 0 0 0 65.412 64H22.588a4.543 4.543 0 0 0-3.246 1.365A4.701 4.701 0 0 0 18 68.667V78M28 46h33M28 51v-8a3 3 0 0 1 3-3h27a3 3 0 0 1 3 3v8" />
      <rect width="9" height="9" x="27" y="24" rx="2" />
      <rect width="9" height="9" x="52" y="24" rx="2" />
      <path d="M18 44c-4.418 0-8-3.358-8-7.5 0-4.142 3.582-7.5 8-7.5M70 29c4.418 0 8 3.358 8 7.5 0 4.142-3.582 7.5-8 7.5M39.226 9L44 14.047l-5 3.803.141.15M46.73 18L52 14.118 43 5" />
      <circle cx="38.5" cy="4.5" r="4.5" />
      <path d="M38 58a3 3 0 1 1 0-6M38 64a3 3 0 1 1 0-6M50 52a3 3 0 0 1 0 6M50 58a3 3 0 0 1 0 6M50 64H38M88 83.5v3a1.513 1.513 0 0 1-1.517 1.5H1.517A1.513 1.513 0 0 1 0 86.5v-3C0 81.015 2.038 79 4.552 79h28.827c.838 0 1.518.672 1.518 1.5s.679 1.5 1.517 1.5h16.69c.837 0 1.517-.672 1.517-1.5S55.3 79 56.138 79h27.31C85.962 79 88 81.015 88 83.5zM17.765 23H8.588a4.607 4.607 0 0 0-3.246 1.328A4.51 4.51 0 0 0 4 27.541V79h26M62 79h21V27.54a4.555 4.555 0 0 0-1.316-3.212A4.474 4.474 0 0 0 78.5 23h-9" />
      <path d="M25 79v-6a3 3 0 0 1 3-3h33a3 3 0 0 1 3 3v6M18 70c-4.418 0-8 3.358-8 7.5V79M70 70c4.418 0 8 3.358 8 7.5V79" />
    </g>
  </svg>
);
